import { render } from "./AdDocumentViewCommentsList.vue?vue&type=template&id=2a84b40c&ts=true"
import script from "./AdDocumentViewCommentsList.vue?vue&type=script&lang=ts"
export * from "./AdDocumentViewCommentsList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__